import { ScoopText, ScoopChip } from '../../../../../../ui'
import styles from './ScreeningCriteria.module.scss'

export const ScreeningCriteria = ({ contextMetadata }) => {
    if (!contextMetadata) return null

    const { purpose, keyMetrics, screeningRules, methodology } = contextMetadata
    const hasContent = purpose || methodology || keyMetrics?.length > 0 || screeningRules

    if (!hasContent) return null

    return (
        <div className={styles.screeningCriteria}>
            <ScoopText className={styles.sectionTitle}>Screening Criteria</ScoopText>

            {purpose && <ScoopText className={styles.purpose}>{purpose}</ScoopText>}

            {methodology && (
                <div className={styles.field}>
                    <ScoopText className={styles.fieldLabel}>Methodology</ScoopText>
                    <ScoopText className={styles.fieldValue}>{methodology}</ScoopText>
                </div>
            )}

            {keyMetrics && keyMetrics.length > 0 && (
                <div className={styles.field}>
                    <ScoopText className={styles.fieldLabel}>Key Metrics</ScoopText>
                    <div className={styles.chipList}>
                        {keyMetrics.map((metric, idx) => (
                            <ScoopChip key={idx} size="small" label={metric} />
                        ))}
                    </div>
                </div>
            )}

            {screeningRules && typeof screeningRules === 'object' && (
                <div className={styles.field}>
                    <ScoopText className={styles.fieldLabel}>Screening Rules</ScoopText>
                    <div className={styles.rulesList}>
                        {Object.entries(screeningRules).map(([key, value]) => (
                            <div key={key} className={styles.ruleRow}>
                                <ScoopText className={styles.ruleKey}>{key}</ScoopText>
                                <ScoopText className={styles.ruleValue}>
                                    {typeof value === 'string' ? value : JSON.stringify(value)}
                                </ScoopText>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    )
}
